import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".vai-header-time {\n  margin-left: 24px;\n  line-height: 48px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.vai-header-time__value {\n  display: inline-block;\n  font-weight: var(--vai-font-weight-semibold);\n  font-size: 21px;\n}\n.vai-header-time__details {\n  display: inline-block;\n  margin-left: 3px;\n  line-height: 7px;\n  font-weight: var(--vai-font-weight-semibold);\n  font-size: 10px;\n}";
styleInject(css_248z,{"insertAt":"top"});

export { css_248z as default };
